<template>
  <Modal :value.sync="visible" :closable="false" :mask-closable="false">
    <p slot="header" style="color: #f60">
      <Icon type="ios-information-circle"></Icon>
      <span>{{ title }}</span>
    </p>
    <div>
      <i-form label-position="top">
        <Form-item v-if="false" label="Phone verification">
          <Row>
            <i-col span="24">
              <i-input :value.sync="valiAccount.phone" disabled></i-input>
            </i-col>
          </Row>
        </Form-item>
        <Form-item v-if="false" label="Phone verification code">
          <Row>
            <i-col span="18">
              <i-input
                maxlength="6"
                v-verify="valiform.phoneCode"
                v-validate="'required'"
                v-model="valiform.phoneCode"
                placeholder="Please enter your phone verification code"
              ></i-input>
            </i-col>
            <i-col span="5" offset="1">
              <i-button
                type="primary"
                :disabled="valiCodeWaiting"
                @click="sendSMS"
                >{{ smsBtnText }}</i-button
              >
            </i-col>
          </Row>
          <label class="error" v-remind="valiform.phoneCode"></label>
        </Form-item>
        <Form-item v-if="useEmail" label="Mailbox verification">
          <Row>
            <i-col span="24">
              <i-input :value.sync="valiAccount.email" disabled></i-input>
            </i-col>
          </Row>
        </Form-item>
        <Form-item v-if="useEmail" label="Mailbox verification code">
          <Row>
            <i-col span="18">
              <i-input
                maxlength="6"
                v-verify="valiform.emailCode"
                v-validate="'required'"
                v-model="valiform.emailCode"
                placeholder="Please enter your email verification code"
              ></i-input>
            </i-col>
            <i-col span="5" offset="1">
              <i-button
                type="primary"
                :disabled="valiCodeEmailWaiting"
                @click="sendEmail"
                >{{ emailBtnText }}</i-button
              >
            </i-col>
          </Row>
          <label class="error" v-remind="valiform.emailCode"></label>
        </Form-item>
        <Form-item v-if="useGoogle" label="Google verification code">
          <Row>
            <i-col span="24">
              <i-input
                maxlength="6"
                v-verify="valiform.googleCode"
                v-validate="'required'"
                v-model="valiform.googleCode"
                placeholder="Please enter the Google verification code"
              ></i-input>
            </i-col>
            <label class="error" v-remind="valiform.googleCode"></label>
          </Row>
        </Form-item>
      </i-form>
    </div>
    <div slot="footer">
      <Row>
        <i-col span="12">
          <i-button
            long
            type="primary"
            @click="submit"
            :disabled="modal_loading"
            >Submit</i-button
          >
        </i-col>
        <i-col span="11" offset="1">
          <i-button long type="ghost" @click="cancel">Return</i-button>
        </i-col>
      </Row>
    </div>
  </Modal>
</template>

<script>
import Vue from "vue";
import { sendSMSMessage, sendSEmailMessage } from "@/plugins/api/security";
import verify from "vue-verify-plugin";
import { googleCodeStatus } from "@/plugins/api/security";
import { baseInfo } from "@/plugins/api/user";
Vue.use(verify, {
  blur: true,
});
export default {
  name: "validateModal",
  props: {
    title: {
      type: String, // 颜色参数类型
      default: "Security information verification", // 默认黑色
    },
    visible: {
      type: Boolean, // 颜色参数类型
      default: false, // 默认黑色
    },
    useGoogle: {
      type: Boolean, // 颜色参数类型
      default: false, // 默认黑色
    },
    useEmail: {
      type: Boolean, // 颜色参数类型
      default: false, // 默认黑色
    },
    usePhone: {
      type: Boolean, // 颜色参数类型
      default: false, // 默认黑色
    }
  },
  data() {
    return {
      modal_loading: false,
      showValiCodeDialog: true,
      valiform: {
        phoneCode: "000000",
        emailCode: "",
        googleCode: "",
      },
      valiAccount: {},
      emailBtnText: "Get code",
      smsBtnText: "Get code",
      valiCodeEmailWaiting: false,
      valiCodeWaiting: false,
      curEmailTimmer: undefined,
      curPhoneTimmer: undefined,
      valiCodePhoneTimmer: 60,
      valiCodeEmailTimmer: 60,
    };
  },
  verify: {
    valiform: {
      phoneCode: [
        {
          test: function (val) {
            if (!this.usePhone) {
              return true;
            }
            if (val.length != 6) {
              return false;
            }
            return true;
          },
          message: "The SMS verification code must be 6 digits",
        },
      ],
      emailCode: [
        {
          test: function (val) {
            if (!this.useEmail) {
              return true;
            }
            if (val.length != 6) {
              return false;
            }
            return true;
          },
          message: "The mailbox verification code must be 6 digits",
        },
      ],
      googleCode: [
        {
          test: function (val) {
            if (!this.useGoogle) {
              return true;
            }
            if (val.length != 6) {
              return false;
            }
            return true;
          },
          message: "The Google verification code must be 6 digits",
        },
      ],
    },
  },
  created() {
    googleCodeStatus().then((status) => {
      if (status == 0) {
        this.enableGoogle = true;
      }
    });

    baseInfo().then((accountRes) => {
      if (accountRes.data && accountRes.data.email) {
        this.valiAccount.email = accountRes.data.email;
      }
    });
  },
  methods: {
    sendEmail(type) {
      this.valiCodeEmailWaiting = true;
      if (!this.curEmailTimmer) {
        this.curEmailTimmer = setInterval(() => {
          this.valiCodeEmailTimmer--;
          this.emailBtnText = this.valiCodeEmailTimmer + "s";
          if (this.valiCodeEmailTimmer <= 0) {
            clearInterval(this.curEmailTimmer);
            this.valiCodeEmailWaiting = false;
            this.curEmailTimmer = undefined;
            this.valiCodeEmailTimmer = 60;
            this.emailBtnText = "Get code";
          }
        }, 1000);
      }
      sendSEmailMessage().then((res) => {
        this.$Notice.success({
          title: "Verification code was sent successfully",
        });
      });
    },
    sendSMS(type) {
      this.valiCodeWaiting = true;
      if (!this.curPhoneTimmer) {
        this.curPhoneTimmer = setInterval(() => {
          this.valiCodePhoneTimmer--;
          this.smsBtnText = this.valiCodePhoneTimmer + "s";
          if (this.valiCodePhoneTimmer <= 0) {
            clearInterval(this.curPhoneTimmer);
            this.valiCodeWaiting = false;
            this.curPhoneTimmer = undefined;
            this.valiCodePhoneTimmer = 60;
            this.smsBtnText = "Get code";
          }
        }, 1000);
      }

      sendSMSMessage().then((res) => {
        this.$Notice.success({
          title: "Verification code was sent successfully",
        });
      });
    },
    cancel() {
      this.valiform = {
        phoneCode: "000000",
        emailCode: "",
        googleCode: "",
      };
      this.$emit("hideValiDialog");
    },
    submit() {
      if (this.$verify.check()) {
        let valiData = {};
        if (this.useGoogle) {
          valiData.googleCode = this.valiform.googleCode;
        }
        if (this.usePhone) {
          valiData.phoneCode = this.valiform.phoneCode;
        }
        if (this.useEmail) {
          valiData.emailCode = this.valiform.emailCode;
        }
        this.valiform = {
          phoneCode: "000000",
          emailCode: "",
          googleCode: "",
        };
        // console.log(valiData)
        this.$emit("onsubmit", valiData);
      }
    },
  },
};
</script>

<style>
.ivu-btn-ghost {
  color: #666 !important;
}
.error {
  color: red;
}
</style>

